(function imageViewerCallToAction(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.FullImageViewer.MoreInfoPanel ||
    !global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const previousImageViewerCallToAction = global.NewHomeSource.ImageViewerCallToAction;
  const queryCallToAction = '[data-full-image-viewer-role="ImageViewerCTA"]';
  const queryScheduleButtonCta = queryCallToAction + ' [data-schedule-button]';
  const callToActionElement = global.document.querySelector(queryCallToAction);
  const eventToAttach = global.NewHomeSource.FullImageViewer.Config.getClickOrTouchEvent();
  const hidden = 'hidden';

  /**
  * @public
  * render: renders the Call to Action.
  *
  * @param {object} data information that is needed to render the image counter.
  */
  function render(data) {
    if (data.IsCtaSlide) {
      callToActionElement.removeAttribute(hidden);
    } else {
      callToActionElement.setAttribute(hidden, true);
    }
  }

  /**
* @private
* openScheduleForm: open schedule form on panel actions.
*
*/
  function openScheduleForm() {
    global.NewHomeSource.FullImageViewer.MoreInfoPanel.openScheduleTourFromCallToAction();
  }

  /**
   * @constructs NewHomeSource.ImageViewerCallToAction
   */
  function ImageViewerCallToAction() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   */
  ImageViewerCallToAction.update = function update(data) {
    requestAnimationFrame(render.bind(this, data));
  };

  const eventsConfiguration = {
    scheculeButton: {
      callbacks: [openScheduleForm],
      events: [eventToAttach],
      elements: queryScheduleButtonCta,
    },
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.ImageViewerCallToAction to the previous script.
   */
  ImageViewerCallToAction.noConflict = function noConflict() {
    global.NewHomeSource.ImageViewerCallToAction = previousImageViewerCallToAction;
    return ImageViewerCallToAction;
  };

  global.NewHomeSource.FullImageViewerState.add('onImageSet', ImageViewerCallToAction);
  global.NewHomeSource.Event(eventsConfiguration);
  global.NewHomeSource.ImageViewerCallToAction = ImageViewerCallToAction;
}(window));
